export interface CheckoutAttribute {
  effectiveDate: string;
  itemIterationId: number;
  netAmount: number;
  periodOfCover: number;
}
